import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { UpsettingDog } from "@/components/Doodle";

export default function NotFound() {
  return (
    <div
      className="mx-auto flex max-w-[800px] flex-col items-center px-6 py-24 text-center md:px-10"
      data-testid="not-found-page"
    >
      <SEO title="Not found" noindex />
      <UpsettingDog className="h-40 w-40 wc-wobble" />
      <div className="font-display mt-6 text-xs font-bold uppercase tracking-[0.3em]">
        404 · certified missing
      </div>
      <h1 className="font-display mt-3 text-5xl font-black tracking-tighter sm:text-7xl">
        This page is damp and gone.
      </h1>
      <p className="mt-4 max-w-md">
        It was probably eaten by a cursed dog. Try one of these instead:
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="wc-btn">
          Home
        </Link>
        <Link to="/shop" className="wc-btn wc-btn-outline">
          Shop
        </Link>
        <Link to="/gallery" className="wc-btn wc-btn-outline">
          Wet Gallery
        </Link>
      </div>
    </div>
  );
}
